import React from 'react'
import { useTranslation } from 'i18n'
import './VoteButtons.scss'
import ServerError from './ServerError'

/*

    2-option voting panel.
    it has no concept of users or services. pure render.

    You probably want to include VotingButton, not this component.

*/

const VoteButtonUI = ({
  id,
  upVotetxt,
  downVotetxt,
  upVoteIcon,
  downVoteIcon,
  voted,
  dispatchVote,
  error,
  alreadyComplete,
}) => {
  const { t } = useTranslation('shared')
  // const [voted, setVoted] = useState()

  return (
    <>
      <div className={`vote-buttons voted-${voted}`}>
        <button
          disabled={voted}
          className="vote-btn btn btn-primary"
          style={{ cursor: 'pointer' }}
          onClick={event => {
            event.preventDefault()
            dispatchVote(id, 'UP', alreadyComplete)
          }}
          aria-label={t('vote.upAriaLabel')}
        >
          <i className={`fa fa-${upVoteIcon}`}></i> {upVotetxt}
        </button>
        <button
          className="vote-btn btn btn-secondary"
          disabled={voted}
          style={{ cursor: 'pointer' }}
          onClick={event => {
            event.preventDefault()
            dispatchVote(id, 'DOWN', alreadyComplete)
          }}
          aria-label={t('vote.downAriaLabel')}
        >
          <i className={`fa fa-${downVoteIcon}`}></i> {downVotetxt}
        </button>
      </div>
      {error && <ServerError />}
    </>
  )
}

export default VoteButtonUI
